/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { RefObject, useEffect } from "react";
import ResizeObserver from "resize-observer-polyfill";

const useResizeObserver = (ref: RefObject<HTMLElement | null>, onResize: (entry: ResizeObserverEntry) => void) => {
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      // Single entry with refs
      const entry = entries.pop();
      if (entry) {
        onResize(entry);
      }
    });

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [onResize, ref]);
};

export default useResizeObserver;
